import { IconButton, InputAdornment, Stack, Typography } from "@mui/material";
import { LeftArrowIcon, SearchIcon } from "src/components/ui/svgIcon/CustomIcons";
import DarkLightModeGradient from "./tracking/DarkLightModeGradient";
import DarkLightMapImg from "./tracking/DarkLightMapImg";
import TrackingInput from "./tracking/TrackingInput";
import { ErrorMessage, Form, Formik } from "formik";
import TrackingValidation from "src/utils/validations/welcome/TrackingValidation";

const ProductTrackingData = {
  title: "رهگیری در زنجیره",
  placeHolder: "کدرهگیری خود را وارد نمائید.",
  helperText: "برای مشاهده جزئیات کدرهگیری را وارد نمائید..",
  description: "از طریق این سامانه امکان پیگیری و تضمین کیفیت محصول در هر یک از مراحل تولید تا تحویل وجود دارد.",
  imageLight: "/images/lightMap.png",
  imageDark: "/images/darkMap.png",
};

const Tracking = ({ id, newTheme }) => {
  const titleColor = "#BCBBBE";
  const trackingLink = process.env.REACT_APP_TRACKING_LINK;

  const handleSubmit = (values) => {
    const cleanUuid = values.uuid.replace(/\D/g, "");
    const flag = "U";
    const slug = cleanUuid.trim().replace(/\D/g, "");
    const FinalUrl = `${trackingLink}/flag=${flag}&uuid=${slug}`;
    window.open(FinalUrl, "_blank", "width=800,height=800,left=100,top=100,resizable=yes,scrollbars=yes");
  };

  return (
    <Stack
      m={{ xs: 0, lg: 6 }}
      my={{ xs: 3 }}
      direction={{ xs: "column-reverse", md: "row" }}
      id={id}
      spacing={{ xs: 1, lg: 6 }}
      justifyContent="center"
      alignItems="center"
    >
      <Stack spacing={6} justifyContent="center" alignItems="center" textAlign="center">
        <DarkLightModeGradient />

        <Typography variant="h6" color={titleColor}>
          {ProductTrackingData.title}
        </Typography>
        <Stack spacing={5}>
          <Stack spacing={2}>
            <Formik
              initialValues={{
                uuid: "",
              }}
              onSubmit={handleSubmit}
              validationSchema={TrackingValidation}
            >
              {({ isValid, setFieldValue }) => (
                <Form>
                  <TrackingInput
                    inputProps={{ maxLength: 21 }}
                    onChange={(e) => setFieldValue("uuid", e.target.value)}
                    placeholder={ProductTrackingData.placeHolder}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon color={"#fff"} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            sx={{ backgroundColor: isValid ? newTheme.text.color.primary : "grey.gm", borderRadius: 1 }}
                            type="submit"
                          >
                            <LeftArrowIcon color={"#0B2544"} />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <ErrorMessage name="uuid" component={Typography} color="error.main" variant="caption" />
                </Form>
              )}
            </Formik>
            <Typography variant="body1" color={titleColor}>
              {ProductTrackingData.helperText}
            </Typography>
          </Stack>

          <Typography variant="subtitle2" color={titleColor}>
            {ProductTrackingData.description}
          </Typography>
        </Stack>
      </Stack>

      <DarkLightMapImg />
    </Stack>
  );
};
export default Tracking;
